import { render, staticRenderFns } from "./storeDialog.vue?vue&type=template&id=6c3f08bb"
import script from "./storeDialog.vue?vue&type=script&lang=js"
export * from "./storeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3f08bb')) {
      api.createRecord('6c3f08bb', component.options)
    } else {
      api.reload('6c3f08bb', component.options)
    }
    module.hot.accept("./storeDialog.vue?vue&type=template&id=6c3f08bb", function () {
      api.rerender('6c3f08bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/storeDialog.vue"
export default component.exports